import { rowFromExcelArray } from "./rowUtils";

export function parseExcelMatrix(data) {
  if (!Array.isArray(data) || data.length < 2) return [];
  return data
    .slice(1)
    .filter((row) => Array.isArray(row) && row.some((c) => String(c ?? "").trim()))
    .map((row, i) => rowFromExcelArray(row, i + 1));
}

export function parseLegacySessionStorage(raw) {
  try {
    const parsed = JSON.parse(raw || "null");
    if (!Array.isArray(parsed) || parsed.length < 2) return [];
    return parseExcelMatrix(parsed);
  } catch {
    return [];
  }
}
